import React, { Component } from 'react';
import $ from "jquery";
import Server from '../../../functions/server';
import { Grid, Image, Input, Button, Form, Checkbox } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

class Combo extends Component {

    state = {
        OpenComboDialog: false, combo: [], combolist: [], allCheck: false
    }

    GetCombos = () => {
        let context = this;
        $.ajax({
            type: 'POST', data: { 'userId': 13 },
            url: Server() + 'combo/get.php',
            success: function(data) {
                console.log(data);
                try {
                    data = JSON.parse(data);
                    context.setState({ OpenComboDialog: true, combo: data })
                } catch (e) {
                    alert('Error TO Generate QRCode');
                }
            },
            error: function(err) {
                context.setState({ load: false });
                alert('Try again!!!')
            }
        });
    }

    selectedCombo = (id) => {
        let context = this;
        this.setState({ load: true, message: 'Getting Combo Spares!!!!' });
        console.log(Server() + 'combo/getcombospares.php');
        console.log(id);
        $.ajax({
            type: 'POST', data: { 'id': id },
            url: Server() + 'combo/getcombospares.php',
            success: function(data) {
                console.log(data)
                context.setState({ load: false })
                try {
                    data = JSON.parse(data);
                    data.map((c) => { c.checked = false; })
                    context.setState({ combolist: data, ComboListDialog: true })
                    
                } catch (error) {
                    alert(error)   
                }
            },
            error: function(err) {
                context.setState({ load: false });
                alert('Try again!!!')
            }
        });
    }

    setSpares = (data) => {
       let spares = this.props.partcode;
       let item = this.props.items;
       let newObject = [];
       let i = 0;
       item.map((c) => { i = c.id; })
       spares.map((obj1) => {
            data.map((obj2) => {
                if (obj1.partno == obj2.partno || obj1.part_alias == obj2.partno) {
                    newObject.push({
                        'tax': obj1.tax, 'status': "Waiting", 'point': obj1.point,
                        'rackno': obj1.rackno, 'aliasId': obj1.id,
                        'ava_stocks': obj1.ava_stocks, 'brand': obj1.brand_id,
                        'dropdown':  obj1.part_alias+"->"+obj1.spare_name+"->"+obj1.partno+"->"+obj1.brand_name,
                        'oldquantity': "", 'partname': obj1.spare_name, 'orderdetailsId': 0,
                        'brand_name': obj1.brand_name, 'part_id': obj1.part_id,
                        'partcode': obj1.part_alias, 'partno': obj1.partno,
                        'uprice': obj1.mrp, 'adjstock': '', 'discountper': obj1.discount ? obj1.discount : 0,
                        'discountrs': 0, 'branch': this.props.branchId,
                        'id': ++i, 'weight': obj1.weight,
                        'quantity': obj2.units
                    })
                }
            })
       })
       item = item.concat(newObject);
       item = item.filter((v,i,a)=>a.findIndex(t=>(t.partno === v.partno))===i)
       this.props.save('items', item);
       this.setState({ OpenComboDialog: false })
    }

    submitspareslist = () => {
        let combolist = this.state.combolist;
        let newComboList = [];
        combolist.map((c) => {
            if (c.checked) {
                newComboList.push(c)
            }
        })
        this.setState({ ComboListDialog: false })
        newComboList = newComboList.filter((v,i,a)=>a.findIndex(t=>(t.partno === v.partno))===i)
        this.setSpares(newComboList);
    }



    CheckBoxChange = name => event => {
        let combolist = this.state.combolist;
        if (name == 'All') {
            combolist.map((c) => {
                if (this.state.allCheck) {
                    c.checked = false;
                }
                else {
                    c.checked = true;
                }
                
            })
            this.setState({ allCheck: !this.state.allCheck, combolist })
        }
        else {
            combolist.map((c) => {
                if (c.id == name) {
                    c.checked = !c.checked;
                }
            })
            this.setState({ allCheck: false, combolist })
        }
    }

    

    render() {
        let { combo, OpenComboDialog, ComboListDialog, combolist } =this.state; 
        let i = 1;
        return (
            <div>
                <Button primary fluid onClick={this.GetCombos}>Select From Combo</Button>
                <Dialog fullWidth={true} maxWidth={"lg"} open={OpenComboDialog} aria-labelledby="responsive-dialog-title">
                    <DialogTitle id="responsive-dialog-title" id="widthdialog">{"Combos"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Grid>
                                {
                                    combo.map((c) => {
                                            return (
                                                <Grid.Column width={4}>
                                                    <Card style={{cursor: 'pointer'}} onClick={ () => this.selectedCombo(c.id) }>
                                                        { c.image ? 
                                                            <img 
                                                            src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/combo/"+c.id+".jpg"} 
                                                            style={{height: '200px', width: '100%'}}/> :
                                                            <img 
                                                            src={"https://vaigaiclaas.com/vdms/icon.png"} 
                                                            style={{height: '200px', width: '100%'}}/>
                                                        }
                                                        <h3>{c.combo_name}</h3>
                                                    </Card>
                                                </Grid.Column>
                                            )
                                    })
                                }
                            </Grid>
                        </DialogContentText>


                        <Dialog fullWidth={true} maxWidth={"lg"} open={ComboListDialog} 
                            onClose={ () => this.setState({ ComboListDialog: false }) }
                            aria-labelledby="responsive-dialog-title">
                            <DialogTitle id="responsive-dialog-title" id="widthdialog">{"Combos"}</DialogTitle>
                            <DialogContent>
                            <table id="table" width='100%'>
                                <tr>
                                    <th id="th"><center>Si</center></th>
                                    <th id="th"><center>Partno</center></th>
                                    <th id="th"><center>Spare name</center></th>
                                    <th id="th"><center>Unit</center></th>
                                    <th id="th"><center>Mrp</center></th>
                                    <th id="th">
                                        <center>
                                            <Checkbox
                                                onChange={this.CheckBoxChange('All')}
                                                checked={this.state.allCheck}
                                            />
                                        </center>
                                    </th>
                                </tr>
                                {
                                    combolist.map((c) => {
                                        return (
                                            <tr>
                                                <td>{i++}</td>
                                                <td>{c.partno}</td>
                                                <td>{c.spare_name}</td>
                                                <td>{c.units}</td>
                                                <td style={{textAlign: 'right'}}>{c.mrp}</td>
                                                <td>
                                                    <center>
                                                        <Checkbox
                                                            onChange={this.CheckBoxChange(c.id)}
                                                            checked={c.checked}
                                                            />
                                                    </center>
                                                
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </table>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={ () => { this.setState({ ComboListDialog: false }) } } 
                                variant="outlined" color="secondary">Close</Button>    
                                <Button onClick={this.submitspareslist} 
                                variant="outlined" color="secondary">Submit</Button>
                            </DialogActions>
                        </Dialog>


                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ OpenComboDialog: false }) } } 
                            variant="outlined" color="secondary">Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default Combo;
